import { useEffect, useRef } from "react";

//Custom hook to simulate did mount (ignore first render)
export const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};
